import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import styled from 'styled-components'

// รูปหลักฐาน แบบเดียวกับหน้า Transaction (thumbnail + preview modal)
const EvidenceImage = ({ images }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const validImages = (images || []).filter(Boolean)

  if (!validImages.length) {
    return <span>ไม่มีรูปภาพ</span>
  }

  const openPreview = (index) => {
    setCurrentImageIndex(index)
    setIsPreviewOpen(true)
  }

  return (
    <div>
      <GalleryContainer>
        {validImages.map((image, index) => (
          <ImageBox key={index} onClick={() => openPreview(index)}>
            <img src={image} alt={`evidence-${index}`} />
          </ImageBox>
        ))}
      </GalleryContainer>
      <Modal
        visible={isPreviewOpen}
        footer={null}
        onCancel={() => setIsPreviewOpen(false)}
        centered
        closable={false}
        width={800}>
        <PreviewImageContainer>
          <img
            src={validImages[currentImageIndex]}
            alt={`preview-${currentImageIndex}`}
          />
        </PreviewImageContainer>
        <ThumbnailContainer>
          {validImages.map((image, index) => (
            <ThumbnailBox
              key={index}
              onClick={() => setCurrentImageIndex(index)}>
              <img src={image} alt={`thumb-${index}`} />
            </ThumbnailBox>
          ))}
        </ThumbnailContainer>
      </Modal>
    </div>
  )
}

EvidenceImage.propTypes = {
  images: PropTypes.array
}

export default EvidenceImage

const GalleryContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ImageBox = styled.div`
  width: 40px;
  height: 40px;
  background-color: #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const PreviewImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px;
  background-color: #f0f0f0;
  padding: 10px 0;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`

const ThumbnailContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
`

const ThumbnailBox = styled.div`
  width: 50px;
  height: 50px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border 0.3s ease;

  &:hover {
    border-color: #3b82f6;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
